// const axios = require('axios')
const request = require('browser-request')
const queryString = require('query-string')

class GatewaySDK {
  constructor (options, app) {
    this.url = options.url
    this.optHost = options.optimizationHost.replace(/\/$/gi, '')
    this.app = app
  }

  get (route, params, callback, version) {
    let qs = ''
    let self = this
    let v = '1.1'
    if (version || (typeof version !== 'undefined' && version.length === 0)) {
      v = version + ''
    }
    if (Object.values(params).length > 0) {
      qs = '?' + queryString.stringify(params)
    }
    request.get({
      url: self.url + v + route + qs,
      json: true,
      body: params
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
  }

  post (route, params, callback, version) {
    let self = this
    let v = '1.1'
    if (version || (typeof version !== 'undefined' && version.length === 0)) {
      v = version + ''
    }
    request.post({
      url: self.url + v + route,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
  }

  delete (route, params, callback, version) {
    let self = this
    let v = '1.1'
    if (version || (typeof version !== 'undefined' && version.length === 0)) {
      v = version + ''
    }
    request({
      method: 'DELETE',
      url: self.url + v + route,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
  }

  download (route, params, callback, version) {
    let qs = ''
    let self = this
    let v = '1.1'
    if (version || (typeof version !== 'undefined' && version.length === 0)) {
      v = version + ''
    }
    if (Object.values(params).length > 0) {
      qs = '?' + queryString.stringify(params)
    }
    request.get({
      url: self.url + v + route + qs,
      body: params
    }, function (err, res, body) {
      console.log('body', body)
      if (err) throw err
      callback(body)
    })
  }

  opt (route, params, callback) {
    request.post({
      url: `${this.optHost}/${route.replace(/^\//gi, '')}`,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
  }

  post2 (url, params, callback) {
    request.post({
      url: url,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
  }

  get2 (url, params, callback) {
    request.get({
      url: url,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
  }
}

export default GatewaySDK



// WEBPACK FOOTER //
// ./src/modules/gateway-sdk/gateway-sdk.js